<template>
  <header id="topHeader">
    <nav class="navbar navbar-expand-lg navbar-light navbar_bg">
      <div class="container-fluid">
        <router-link
          v-if="hasPermission(Owner.ownerDashboard)"
          :to="web.Owner.DASHBOARD_URL.path"
          class="navbar-brand brand_name menu_font_detail home-logout"
        >
          {{ web.Owner.DASHBOARD_URL.title }}
        </router-link>
        <button
          class="navbar-toggler mobile_nav_toggle"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul
            class="
              navbar-nav
              dashboard_nav
              me-auto
              mb-2 mb-lg-0
              menu_font_detail
            "
          >
            <li class="nav-item">
              <router-link
                v-if="hasPermission(Owner.ownerReports)"
                :to="web.Owner.REPORT_URL.path"
                class="nav-link menu_font_detail"
              >
                {{ web.Owner.REPORT_URL.title }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                v-if="hasPermission(Owner.ownerRead)"
                :to="web.Owner.OWNERS_URL.path"
                class="nav-link menu_font_detail"
              >
                {{ web.Owner.OWNERS_URL.title }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                v-if="hasPermission(Owner.ownerCompanySetupRead)"
                :to="web.Owner.SERVICES_URL.path"
                class="nav-link menu_font_detail"
              >
                {{ web.Owner.SERVICES_URL.title }}
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav dashboard_nav d-flex menu_font_detail">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle menu_font_detail"
                href="#"
                id="navbarScrollingDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  v-bind:class="
                    currentPath ===
                    web.Owner.path + '/' + web.Owner.PROFILE_URL.path
                      ? 'nav-active'
                      : ''
                  "
                  >{{ $store.getters.userName }}</span
                >
              </a>
              <ul
                class="dropdown-menu intercity_login_dropdown me-3"
                aria-labelledby="navbarScrollingDropdown"
              >
                <li>
                  <p style="display: none" id="logoutMessage">
                    {{ logoutMessage }}
                  </p>
                  <button
                    onclick="logoutMessageAndroid(document.getElementById('logoutMessage').innerHTML)"
                    @click="logout"
                    class="dropdown-item text-dark menu_font_detail"
                  >
                    {{ web.Default.LOGOUT_URL.title }}
                  </button>
                </li>
                <li></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import store from "@/store";
import web from "@/urls/web";
import permission from "@/modules/permission";
import roles from "@/modules/roles";

const { hasPermission } = permission();
const { Owner } = roles();

export default {
  name: "OwnerNav",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const currentPath = computed(() => route.path);
    const logoutMessage = "logout sucessfully";

    const logout = () => {
      store
        .dispatch("logout")
        .then(() => {
          router
            .push(web.Default.LOGIN_URL.path)
            .catch((error) => console.log(error));
          store.reset();
        })
        .catch(() => {
        });
    };

    return {
      currentPath,
      Owner,
      web,
      hasPermission,
      logout,
      logoutMessage,
    };
  },
};
</script>

<style scoped>
nav .active,
nav .exact-active,
.nav-active {
  color: #ff6347 !important;
  outline: none;
}

.dashboard_nav li a:hover {
  color: #ff6347 !important;
}
</style>
